import { useContext } from 'react';

import { SessionDataContext } from './SessionDataContext';

export const useSessionData = () => useContext(SessionDataContext);
